import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMatch, useNavigate } from "react-router-dom";
import searchIcon from "../../assets/images/search.svg";
import { searched } from "../../features/filter/filterSlice";

const Search = () => {
  const { search } = useSelector((state) => state.filter);
  const [searchText, setSearchText] = useState(search);
  const dispatch = useDispatch();
  //navigation import
  const match = useMatch("/");
  const navigate = useNavigate();
  const handleChange = (e) => {
    setSearchText(e.target.value);
  };

  const handleSearch = (e) => {
    e.preventDefault();
    dispatch(searched(searchText));
    // redirect user to home page if not
    if (!match) {
      navigate("/");
    }
  };

  useEffect(() => {
    setSearchText(search);
  }, [search]);
  return (
    <form onSubmit={(e) => handleSearch(e)}>
      <div className='border border-slate-200 flex items-center bg-white h-10 px-5 rounded-lg text-sm ring-emerald-200'>
        <input
          value={searchText}
          onChange={(e) => handleChange(e)}
          className='outline-none border-none mr-2'
          type='search'
          name='search'
          placeholder='Search'
        />
        <button type='submit'>
          <img className='inline h-4 cursor-pointer' src={searchIcon} alt='Search' />
        </button>
      </div>
    </form>
  );
};

export default Search;
